<template>
  <v-row>
    <v-col xs="12" sm="12" md="12" lg="6" class="pa-0">
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Railroad_On/Under_${rowId}`"
        label="F.02 On/Under"
        :refTable="REFERENCE_TABLE.ON_UNDER"
        v-model="selectedRow.onUnder"
      >
      </LabelSelect>
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Highway_Feature_Type_${rowId}`"
        label="F.03 Feature Type"
        :refTable="REFERENCE_TABLE.FEATURE_TYPE"
        v-if="$vuetify.display.mdAndDown"
        v-model="selectedRow.featureType"
      >
      </LabelSelect>

      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_RR_Name_${rowId}`"
        label="RD.02 RR Name"
        :refTable="REFERENCE_TABLE.RAILROAD_NAME"
        v-model="selectedRow.rrName"
      >
      </LabelSelect>

      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Service_Status_${rowId}`"
        label="RD.03 Service Status"
        :refTable="REFERENCE_TABLE.SERVICE_STATUS"
        v-model="selectedRow.rrServStatus"
      >
      </LabelSelect>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_RR_Milepost_${rowId}`"
        label="RD.04 RR Milepost"
        v-model="selectedRow.rrMilePost"
        maxlength="10"
      >
      </LabelText>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_AAR_DOT_Number_${rowId}`"
        label="RD.05 AAR DOT Number"
        v-model="selectedRow.aarDotNum"
        maxlength="7"
      >
      </LabelText>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Number_of_Electrified_Tracks_${rowId}`"
        label="RD.06 Number of Electrified Tracks"
        v-model="selectedRow.elecTrackQty"
        maxlength="2"
      >
      </LabelText>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Total_Number_of_Tracks_${rowId}`"
        label="RD.07 Total Number of Tracks"
        v-model="selectedRow.lanes"
        maxlength="2"
      >
      </LabelText>
    </v-col>
    <v-col class="pa-0">
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Railroad_Feature_Type_${rowId}`"
        label="F.03 Feature Type"
        v-if="$vuetify.display.lgAndUp"
        :refTable="REFERENCE_TABLE.FEATURE_TYPE"
        v-model="selectedRow.featureType"
      >
      </LabelSelect>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Minimum_Lateral_Under_Right_${rowId}`"
        label="SC.05 Minimum Lateral Under (Right)"
        :decimalPlaces="1"
        type="number"
        appendWith="ft"
        v-model="structure.structureBridge.hclrUrt"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Minimum_Lateral_Under_Left_${rowId}`"
        label="SC.06 Minimum Lateral Under (Left)"
        :decimalPlaces="1"
        type="number"
        appendWith="ft"
        v-model="structure.structureBridge.hclrUlt"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Minimum_Over_Vertical_Right_${rowId}`"
        label="B.RR.02 Minimum Over Vertical (Right)"
        appendWith=" ft"
        v-model="selectedRow.minOverVertClearRight"
        type="number"
        :decimalPlaces="2"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Minimum_Over_Vertical_Left_${rowId}`"
        label="B.RR.03 Minimum Over Vertical (Left)"
        appendWith=" ft"
        type="number"
        :roundingFactor="ROUNDING_FACTOR.TENTH"
        :decimalPlaces="1"
        v-model="selectedRow.totHorClearRight"
      >
      </LabelText>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="12" class="pa-0">
      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_Span_Description_${rowId}`"
        label="RD.08 Span Description"
        v-model="selectedRow.spanDesc"
        maxlength="200"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>

      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_Additional_Operator_${rowId}`"
        label="RD.09 Additional Operator"
        v-model="selectedRow.addOperDesc"
        maxlength="200"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>

      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_FR16_Notes_${rowId}`"
        label="RD.01 Notes"
        v-model="selectedRow.notes"
        maxlength="2000"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";

import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";


export default {
  name: "InspectionFeaturesRailroad",
  props: {
    rowId: { default: 0 },
  },
  setup(props) {
    const inspectionStore = useInspectionStore();
    let selectedRow = computed(() => inspectionStore.getFeatureIntersectionSelectedRow(props.rowId));

    let structure = computed(() => inspectionStore.selectedInspection);

    return {
      REFERENCE_TABLE,
      selectedRow,
      structure,
      ROUNDING_FACTOR,
    };
  },
  components: {
    LabelSelect,
    LabelText,
  },
};
</script>
